// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"b81a9536","453":"7340dbaa"}[chunkId] + ".chunk.js";
};